import React from "react";
import Table from "../../../parts/table/Table";
import {
  UserCircleIcon,
  RefreshIcon,
} from "@heroicons/react/outline";

function HistoryScoinTable(props) {
  const columns = [
    {
      Header: "No",
      accessor: "id",
    },
    {
      Header: "Dibuat",
      accessor: "dibuat",
    },
    {
      Header: "ID Konten",
      accessor: "id_konten",
    },
    {
      Header: "Transaksi",
      id: "transaksi",
      Cell: ({ row }) => {
        return (
          <div className="flex flex-row mx-4 justify-center">
            <UserCircleIcon className="h-6 w-6" />
            <RefreshIcon className="h-6 w-6 mx-2 text-blue-300" />
            <UserCircleIcon className="h-6 w-6" />
          </div>
        );
      },
    },
    {
      Header: "Keterangan",
      accessor: "keterangan",
    },
    {
      Header: "Kode",
      accessor: "kode",
    },
    {
      Header: "ID Transaksi",
      accessor: "id_transaksi",
    },
    {
      Header: "Nominal",
      accessor: "nominal",
    },
    {
      Header: "Status",
      id: "status",
      Cell: ({ row }) => {
        if (row.original.status !== 1) {
          return <p className="text-sm text-red-400">Return</p>;
        } else {
          return <p className="text-sm text-green-200">Berhasil</p>;
        }
      },
    },
  ];
  let data = [
    {
      id: 1,
      dibuat: "2021",
      id_konten: "2021",
      transaksi: 1,
      keterangan: 35,
      kode: 35,
      id_transaksi: 35,
      nominal: 35,
      status: 1,
    },
    {
      id: 2,
      dibuat: "2021",
      id_konten: "2021",
      transaksi: 1,
      keterangan: 35,
      kode: 35,
      id_transaksi: 35,
      nominal: 35,
      status: 0,
    },
  ];
  return (
    <>
      <Table columns={columns} data={data} />
    </>
  );
}

HistoryScoinTable.propTypes = {};

export default HistoryScoinTable;
